import Joi from 'joi';


export const VALIDATION_LIST_BIDDING_CATEGORY = {
    options: {allowUnknownBody: false},
    body: {
        projectId                               : Joi.string().required(),
    }
};


export const VALIDATION_DETAIL_BIDDING_CATEGORY = {
    options: {allowUnknownBody: false},
    params: {
        id: Joi.string().required()
    }
};


export const VALIDATION_DELETE_BIDDING_CATEGORY = {
  options: {allowUnknownBody: false},
  body: {
    projectId: Joi.string().required(),
    id: Joi.string().required(),
    deleteById: Joi.string().required(),
    deleteByType: Joi.string().valid('project', 'contractor').required(),
  }
};


export const VALIDATION_BIDDING_CATEGORY_APPROVE = {
  options: { allowUnknownBody: false },
  body: {
    id: Joi.number().required(),
    approved: Joi.number().required(),
  }
};


export const VALIDATION_CREATE_BIDDING_ITEM = {
    options: {allowUnknownBody: false},
    body: {

        name                                    : Joi.string().required(),
        typeOfBid                               : Joi.string().valid('public', 'private').required(),
        bidOpenTime                             : Joi.date().required(),
        bidCloseTime                            : Joi.date().required(),
        allowAlternativeBids                    : Joi.boolean().required(),
        allowSealedBids                         : Joi.boolean().required(),
        expectTypeOfContractor                  : Joi.string(),
        expectCountryOfContractor               : Joi.string(),
        expectCityOfContractor                  : Joi.string(),
        expectDistrictOfContractor              : Joi.string(),
        expectExperienceContractor              : Joi.number(),
        expectRatingOfContractor                : Joi.number(),
        expectRevenueOfContractor               : Joi.number(),
        expectUnitRevenueOfContractor           : Joi.string(),
        expectOtherRequirements                 : Joi.string(),
        documents                               : Joi.array().items(Joi.object()),
        works                                   : Joi.array().items(Joi.object()),
        materials                               : Joi.array().items(Joi.object()),
        preferredCurrency                       : Joi.string().required(),
        invitedEmails                           : Joi.array().items(Joi.string()),
        invitedFromFavorites                    : Joi.array().items(Joi.object().keys({
            id: Joi.string(),
            type: Joi.string().valid('contractor', 'user'),
        })),
        projectId                               : Joi.string().required(),
    }
};
    
    
export const VALIDATION_UPDATE_BIDDING_ITEM = {
    options: {allowUnknownBody: false},
    body: {
      id: Joi.string().required(),
      updateById: Joi.string().required(),
      updateByType: Joi.string().valid('project', 'contractor').required(),
      name: Joi.string(),
      listImages: Joi.array().items(Joi.string()),
      typeOfBid: Joi.string(),
      bidOpenTime: Joi.date(),
      bidCloseTime: Joi.date(),
      allowAlternativeBids: Joi.boolean(),
      allowSealedBids: Joi.boolean(),
      expectTypeOfContractor: Joi.string(),
      expectCountryOfContractor: Joi.string(),
      expectCityOfContractor: Joi.string(),
      expectDistrictOfContractor: Joi.string(),
      expectExperienceContractor: Joi.number(),
      expectRatingOfContractor: Joi.number(),
      expectRevenueOfContractor: Joi.number(),
      expectUnitRevenueOfContractor: Joi.string(),
      expectOtherRequirements: Joi.string(),
      documents: Joi.array().items(Joi.object()),
      works: Joi.array().items(Joi.object()),
      materials: Joi.array().items(Joi.object()),
      preferredCurrency: Joi.string(),
      invitedEmails: Joi.array().items(Joi.string()),
      projectId: Joi.string().required(),
    }
};
    
//
// export const VALIDATION_EXTRAS_CREATE_RATING = {
//     options: {allowUnknownBody: false},
//     body: {
//         star: Validation.RANKING.required(),
//         content: Validation.DESCRIPTION.required(),
//         ownerId: Joi.number().required(),
//         ownerType: Joi.string().valid(CONTRACTOR, ACCOUNT, PROJECT).required(),
//         senderId: Joi.number().required(),
//         senderType: Joi.string().valid(CONTRACTOR, ACCOUNT).required()
//     }
// };
    
    
export const VALIDATION_EXTRAS_EXIST_RATING = {
    options: {allowUnknownBody: false},
    body: {
        ownerId: Joi.number().required(),
        senderId: Joi.number().required()
    }
};
    
    
// export const VALIDATION_EXTRAS_CREATE_DOCUMENT = {
//     options: {allowUnknownBody: false},
//     body: {
//         name: Validation.NAME.required(),
//         url: Joi.string().required(),
//         type: Joi.string().required(),
//         idFile: Joi.string().required(),
//         ownerId: Joi.number().required(),
//         ownerType: Joi.string().valid(CONTRACTOR, PROJECT, BIDDING_CATEGORY, BIDDING).required()
//     }
// };
    
    
export const VALIDATION_EXTRAS_GET_CANDIDATE_RATING = {
    options: {allowUnknownBody: false},
    body: {}
};



// WEBPACK FOOTER //
// ./src/services/biddingCategory/BiddingCategory.Validator.js